import { defineStyleConfig } from '@chakra-ui/react';

export const Spinner = defineStyleConfig({
  baseStyle: {
    color: 'neutral.1000',
  },
});
